import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-simple-data-transfer-statement-approval-dialog',
  templateUrl: './simple-data-transfer-statement-approval-dialog.component.html',
  styleUrls: ['./simple-data-transfer-statement-approval-dialog.component.scss']
})
export class SimpleDataTransferStatementApprovalDialogComponent implements OnInit {
  /**
   *
   */
 
  acceptText: string;
  accepTextOrig: string;
  /**
   *
   */
  constructor( 
    private dialogRef: MatDialogRef<SimpleDataTransferStatementApprovalDialogComponent>,
    private translateService: TranslateService

  ) {
    
    
  }
  ngOnInit(): void {
    this.accepTextOrig = this.translateService.instant("invoice_details.simple_data_transfer_statement")
        let termsUrl : string;
    let privacyUrl : string;
    let currLang = this.translateService.getLangs();
    if (currLang[0] === 'hu') termsUrl = sessionStorage.getItem('huPrivacyPolicyUrl')
    if (currLang[0] === 'en') termsUrl = sessionStorage.getItem('enPrivacyPolicyUrl');
    if (currLang[0] === 'de') termsUrl = sessionStorage.getItem('dePrivacyPolicyUrl');
    if (currLang[0] === 'fr') termsUrl = sessionStorage.getItem('frPrivacyPolicyUrl');
    if (currLang[0] === 'sk') termsUrl = sessionStorage.getItem('skPrivacyPolicyUrl');
    this.acceptText = this.accepTextOrig.replace("#policy#",termsUrl)

  }
  cancel() {
    this.dialogRef.close(undefined)
  }
  submit() {

    this.dialogRef.close("ok")
  }
}
